import myheader from './myheader.vue'
import mynav from './mynav.vue'
import myfooter from './myfooter.vue'
import myupload from './myupload.vue'
import channelConfig from './channelConfig.vue'
import scancode from './scancode.vue'
import orderdetails from './orderdetails.vue'
import memo from './memo.vue'
import workdialog from './workdialog.vue'
import work from './work.vue'
import service from './service.vue'
import servicedetails from './servicedetails.vue'
import gaidanhao from './gaidanhao.vue'
import workdetails from './workdetails.vue'
import scancodebuy from './scancodebuy.vue'
import richText from './richText.vue'
import rtext from './rtext.vue'
import ctext from './ctext.vue'
import forget from './forget.vue'
import add from './add.vue'
import mtext from './mtext.vue'
import pddsku from './pddsku.vue'

const common = {
	install:function(Vue){
		Vue.component('myheader',myheader),
		Vue.component('mynav',mynav),
		Vue.component('myfooter',myfooter),
		Vue.component('myupload',myupload),
		Vue.component('channelConfig',channelConfig),
		Vue.component('scancode',scancode),
		Vue.component('orderdetails',orderdetails),
		Vue.component('memo',memo),
		Vue.component('workdialog',workdialog),
		Vue.component('work',work),
		Vue.component('service',service),
		Vue.component('servicedetails',servicedetails),
		Vue.component('gaidanhao',gaidanhao),
		Vue.component('workdetails',workdetails),
		Vue.component('scancodebuy',scancodebuy),
		Vue.component('richText',richText),
		Vue.component('rtext',rtext),
		Vue.component('ctext',ctext),
		Vue.component('forget',forget),
		Vue.component('add',add),
		Vue.component('mtext',mtext),
		Vue.component('pddsku',pddsku)
	}
}

export default common


// WEBPACK FOOTER //
// ./src/common/index.js